import React from "react";
import { SimpleShowLayout, TextField, NumberInput } from "react-admin";

const FormTab = (props) => {
  return (
    <SimpleShowLayout {...props}>
      <TextField source="football.id" />
      <NumberInput source="football.passingCompletions" />
      <NumberInput source="football.passingAttempts" />
      <NumberInput source="football.passingYards" />
      <NumberInput source="football.passingTouchdowns" />
      <NumberInput source="football.passingInterceptions" />
      <NumberInput source="football.passingCompletionPercentage" />
      <NumberInput source="football.rushingAttempts" />
      <NumberInput source="football.rushingYards" />
      <NumberInput source="football.rushingTouchdowns" />
      <NumberInput source="football.rushingAverage" />
      <NumberInput source="football.receptions" />
      <NumberInput source="football.receivingYards" />
      <NumberInput source="football.receivingTouchdowns" />
      <NumberInput source="football.receivingAverage" />
      <NumberInput source="football.totalPoints" />
    </SimpleShowLayout>
  );
};

export default FormTab;
